<template>
  <div class="invoices">
    <h3 class="p-mt-2 p-mb-4">{{ $t('admin.invoices.title') }}</h3>

    <DataTable :value="invoices" stripedRows 
      responsiveLayout="stack" dataKey="transactionId" 
       breakpoint="900px" sortField="paidAt" :sortOrder="-1">
      <template #empty>
          {{$t('admin.invoices.empty_list')}}
      </template>
      <template #loading>
          {{$t('admin.invoices.loading_list')}}
      </template>
      <Column field="paidAt" :header="$t('admin.invoices.col_date')">
        <template #body="slotProps">
          {{ $d(new Date(slotProps.data.updatedAt), 'long') }}
        </template>
      </Column>
      <Column field="plans" :header="$t('admin.invoices.col_description')">
        <template #body="slotProps">
          <div class="p-d-flex p-flex-column" style="gap: 5px;">
            <div v-for="item in slotProps.data.plans" :key="item.id">
              {{ item.serialNumber }} - {{ $t(`plans.codes.${item.code}`) }}
            </div>
          </div>
        </template>
      </Column>
      <Column field="paymentMethod" :header="$t('admin.invoices.col_paymentMethod')">
       <template #body="slotProps">
            {{ !slotProps.data.paymentMethod ? '' : ['PAYPAL', 'UNKNOWN'].includes(slotProps.data.paymentMethod) ? $t(`admin.invoices.payment_methods.${slotProps.data.paymentMethod}`) : slotProps.data.paymentMethod }}
        </template>
      </Column>
      <Column field="status" :header="$t('admin.invoices.col_status')">
        <template #body="slotProps">
          <div class="p-text-center">
            <img v-if="slotProps.data.status == 'PENDING' && slotProps.data.sessionUrl" :src="`/assets/irinox/icons/${getStatusIcon(slotProps.data.status)}`" class="p-mr-2" :style="{ height: '32px', cursor: 'pointer' }" 
              v-tooltip.top="$t(`admin.invoices.status.${slotProps.data.status}`)" :alt="$t(`admin.invoices.status.${slotProps.data.status}`)" @click="redirectToPayment(slotProps.data.sessionUrl)"/>
            <img v-else :src="`/assets/irinox/icons/${getStatusIcon(slotProps.data.status !== 'PENDING' ? slotProps.data.status : 'ERROR')}`" class="p-mr-2" :style="{ height: '32px' }" 
              v-tooltip.top="$t(`admin.invoices.status.${slotProps.data.status !== 'PENDING' ? slotProps.data.status : 'ERROR'}`)" :alt="$t(`admin.invoices.status.${slotProps.data.status !== 'PENDING' ? slotProps.data.status : 'ERROR'}`)"/>
          </div>
        </template>
      </Column>
      <Column class="" :header="$t('admin.invoices.col_invoice')">
        <template #body="slotProps">
          <div class="p-text-center">
            <img v-if="slotProps.data.stripeReceiptUrl" src="/assets/irinox/icons/download_invoice.svg" alt="Download Invoice" class="p-mr-2" style="height: 32px; cursor: pointer;" v-tooltip.top="$t(`common.download`)" @click="downloadInvoice(slotProps.data.stripeReceiptUrl)" />
          </div>
        </template>
      </Column>
      <Column />
    </DataTable>

    <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('details.dialog_error')" :life="3000"
      @update:visible="dialog.error = $event" />

  </div>
</template>

<script>
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
export default {
  components: {
    IrinoxDialogDark
  },
  setup() {
    // nessuna logica per ora
  },
  props: {
    invoices: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: {
        error: false,
      }
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getStatusIcon(status) {
      switch(status) {
        case 'PENDING':
          return 'payment_pending.svg';
        case 'PAID':
          return 'payment_success.svg';
        case 'ERROR':
          return 'payment_cancel.svg';
        default:
          return null;
      }
    },
    redirectToPayment(sessionUrl) {
      this.$window.location.href = sessionUrl;
    },
    downloadInvoice(receiptUrl) {
      this.$window.open(receiptUrl, '_blank');
    }
  },
}
</script>

<style scoped>
</style>